import { get, post } from '../request';

//获取轮播图列表
function getBannerList(params) {
  return get('/wdsx-shop/homePageBanner/getBannerList', params);
}

//获取推荐供应商列表
function getShopList(params) {
  return get('/wdsx-shop/supplier/getShopSupplieerPage', params);
}

//获取推荐商品
function getGoodsList(params) {
  return get('/wdsx-shop/goods/getHomePageGoods', params);
}
export default {
  getBannerList,
  getShopList,
  getGoodsList
};
